import { useState, useEffect } from 'react';
import { store } from '../utils/store';

export function useStore() {
  const [state, setState] = useState(() => store.get());
  useEffect(() => store.subscribe(() => setState(store.get())), []);
  return state;
}
